(function () {
  "use strict";

  angular
    .module("alk.import")
    .controller("importModalController", importModalController);

  importModalController.$inject = ["$uibModalInstance", "$scope", "$translate", "alkModalService", "papaparse", "$timeout", "alkImportService", "$interval"];

  function importModalController($uibModalInstance, $scope, $translate, alkModalService, papaparse, $timeout, alkImportService, $interval) {
    var vm = this;

    vm.clickUpload = clickUpload;
    vm.processFile = processFile;
    vm.processFileLogic = processFileLogic;
    vm.cancel = cancel;
    vm.canSubmit = canSubmit;
    vm.keydownOnFileInput = keydownOnFileInput;
    vm.getFileMessage = getFileMessage;
    vm.getDisplayErrors = getDisplayErrors;
    vm.getDetectedDelimiter = getDetectedDelimiter;
    vm.showDetectedDelimiter = showDetectedDelimiter;
    vm.validate = validate;
    vm.submit = submit;
    vm.errors = [];
    vm.showEmptySetWarning = false; //Don't show the empty set warning when the form first loads
    vm.submitted = false;

    alkModalService.setWizardCleanupFunction(onWizardClose);
    var currentWizardData = alkModalService.getCurrentWizardData();

    vm.oldBrowser = currentWizardData.oldBrowser;

    if(!currentWizardData.file) { currentWizardData.file = null; }
    if(!currentWizardData.sets) { currentWizardData.sets = []; }
    if(!currentWizardData.importRows) { currentWizardData.importRows = []; }
    if(!currentWizardData.delimiter) { currentWizardData.delimiter = "AutoDetect"; }
    if(!currentWizardData.detectedDelimiter) { currentWizardData.detectedDelimiter = ""; }

    vm.file = currentWizardData.file;
    vm.importRows = currentWizardData.importRows;
    vm.delimiter = currentWizardData.delimiter;
    vm.detectedDelimiter = currentWizardData.detectedDelimiter;
    vm.sets = currentWizardData.sets;

    var importFeatureType = currentWizardData.importFeatureType;
    vm.isPlacesImport = (importFeatureType === "ContentToolsPlaces");
    vm.isExceptionsImport = (importFeatureType === "ContentToolsExceptions");
    vm.isStopsImport = (importFeatureType === "PCMWebUIStops");

    if (vm.isPlacesImport) {
      vm.importModalTitle = $translate.instant("templates.importPlaces.importPlacesTitle");
      vm.entityNameText = $translate.instant("templates.importPlaces.places");
      vm.submitButtonText = $translate.instant("common.Continue");
      vm.maxRowsAllowed = 50000;
    }
    else if(vm.isStopsImport) {
      vm.importModalTitle = $translate.instant("templates.importStops.importStopsTitle");
      vm.entityNameText = $translate.instant("templates.importStops.stops");
      vm.submitButtonText = $translate.instant("common.Continue");
      vm.maxRowsAllowed = 40;
    }
    else if(vm.isExceptionsImport) {
      //Exceptions(Modifiers) import works very differently (i.e. DAT file, no geocoding) - use different functions.
      vm.importModalTitle = $translate.instant("templates.importModifiers.importModifiers");
      vm.submitButtonText = $translate.instant("common.Submit");
      vm.validate = validateExceptions;
      vm.processFileLogic = processFileLogicExceptions;
    }

    init();

    ////////////////

    function init() {
      if (!vm.importRows) {
        vm.importRows = [];
      }
      //Fix an issue with IE/Edge with binding the elements
      if(angular.element(document)[0].documentMode || /Edge/.test(navigator.userAgent)) {
        //console.log("ie/edge");
        bindElementsIEFix();
      } else {
        //console.log("Not ie/edge")
        $timeout(function () {
          bindElements();
        });
      }
    }

    function bindElements() {

      //Manually bind the file input onchange because this version of Angular doesn't have ng-change for file inputs
      angular.element("#importSetFileInput").off();
      angular.element("#importSetFileInput").on("change", vm.processFile);

      //Setup drag and drop file upload div
      angular.element("#importForm").off();
      angular.element("#importForm").on("drag dragstart dragend dragover dragenter dragleave drop", function(e) {
        e.preventDefault();
        e.stopPropagation();
      });
      var dragDropDiv = angular.element("#dragDropFileDiv");
      dragDropDiv.off();
      dragDropDiv.on("dragover dragenter", function() {
        $timeout(function () {
          vm.fileUploadHover = true;
        });
      }).on("dragleave dragend drop", function() {
        $timeout(function () {
          vm.fileUploadHover = false;
        });
      }).on("drop", function(e) {
        vm.processFileLogic(e.originalEvent.dataTransfer.files[0]);
      });

      angular.element("#importForm").trigger("drag");

    }

    function bindElementsIEFix() {
      //For some reason, IE can fail randomly to bind elements for some reason if going back from previous modal. Must bind it repeatedly to ensure it works
      vm.interval = $interval(bindElements, 100);
      $scope.$on("$destroy", function() {
        $interval.cancel(vm.interval);
      });
    }

    function getDelimiter() {
      var delimiter = ",";
      switch (vm.delimiter) {
        case "AutoDetect":
          delimiter = null;
          break;
        case "Comma":
          delimiter = ",";
          break;
        case "Tab":
          delimiter = "\t";
          break;
        case "Pipe":
          delimiter = "|";
          break;
        default:
          break;
      }
      return delimiter;
    }

    function onWizardClose() {
      //Whatever is done when showing the list in the fourth modal, also do it when the whole import modal closes
      if (vm.isExceptionsImport) {}
      else
        if (currentWizardData.onShowList) currentWizardData.onShowList();
    }

    function clickUpload() {
      $timeout(function() {
        vm.file = null;
        vm.errors = [];
        vm.detectedDelimiter = "";
        document.getElementById("importSetFileInput").value = null;
        vm.validate(true);
        angular.element("#importSetFileInput").trigger("click");
      });
    }

    function processFile() {
      $timeout(function() {
        var file = document.getElementById("importSetFileInput").files[0];
        vm.processFileLogic(file);
      });
    }

    //Given an array of array of strings of results, trim each string of whitespaces from beginning to end. Does it in place.
    function trimParseResults(results) {
      for (var i = 0; i < results.length; i++) {
        for (var j = 0; j < results[i].length; j++) {
          results[i][j] = results[i][j].trim();
        }
      }
    }

    function processFileLogic(file) {
      vm.file = file;
      vm.errors = [];
      vm.importRows = [];
      vm.detectedDelimiter = "";
      if (!file) {
        return;
      }
      vm.fileProcessing = true;
      var config = {
        skipEmptyLines: true,
        complete: function (results) {
          $timeout(function () {
            vm.fileProcessing = false;
            for(var err of results.errors) {
              if(err.code === "UndetectableDelimiter") {
                vm.errors = [ $translate.instant("common.import.delimiterNotDetected") ];
                return;
              }
            }
            vm.detectedDelimiter = results.meta.delimiter;
            vm.importRows = results.data;
            trimParseResults(vm.importRows); //papaparse doesn't remove whitespace before and after, so do it now.
            vm.validate();
          });
        },
        error: function (errorResults) {
          $timeout(function () {
            vm.errors = [$translate.instant("common.import.csvErrGenericFileReadErr")];
            vm.fileProcessing = false;
          });
        }
      };
      var delim = getDelimiter();
      if(delim) {
        config.delimiter = delim;
      }
      papaparse.parse(file, config);
    }

    function showDetectedDelimiter() {
      return vm.delimiter === "AutoDetect" && vm.detectedDelimiter;
    }

    function getDetectedDelimiter() {
      var delim = vm.detectedDelimiter;
      if(delim === "\t") {
        delim = $translate.instant("common.import.tabDelimLabel");
      } else {
        delim = "\"" + delim + "\"";
      }
      return $translate.instant("common.import.autoDetectedDelimiter", { delim: delim });
    }

    //Get the majority array size in an array of arrays
    function getMajorityColumnNum(arrayOfArrays) {
      var max = -1,
        maxKey = -1,
        rowLenToFrequency = {};
      for (var i = 0; i < arrayOfArrays.length; i++) {
        var rowLen = arrayOfArrays[i].length;
        if (!rowLenToFrequency[rowLen]) {
          rowLenToFrequency[rowLen] = 0;
        }
        rowLenToFrequency[rowLen]++;
      }
      _.forOwn(rowLenToFrequency, function (value, key) {
        if (value > max) {
          max = value;
          maxKey = key;
        }
      });
      return maxKey;
    }

    function getFileMessage() {
      return vm.file ? vm.file.name : $translate.instant("common.import.noFileSelected");
    }

    //If onlySetName = true, ONLY validate the set name. Leave the other errors untouched. Otherwise clear the errors and validate all from scratch.
    //This parameter is included for performance (so we don't revalidate a huge CSV everytime the set name text changes)
    function validate(onlySetName) {

      //If no file selected, don't validate file
      if (!vm.file) {
        return;
      }

      //Verify that there were rows
      if (vm.importRows.length === 0) {
        vm.errors.push($translate.instant("common.import.csvErrNoData"));
        return vm.errors;
      }

      //Verify that the maximum row count isn't exceeded
      if (vm.importRows.length > vm.maxRowsAllowed) {
        vm.errors.push($translate.instant("common.import.csvErrTooManyRows", {
          max: String(vm.maxRowsAllowed)
        }));
        return vm.errors;
      }

      var majColNum = getMajorityColumnNum(vm.importRows);
      //Verify that columns have at least 2 fields (lat/lon must be provided as minimum)
      if (majColNum < 2) {
        vm.errors.push($translate.instant("common.import.csvErrNotEnoughCols"));
      }

      //Validate equal columns in each row
      var unequalColErrs = [];
      for (var i = 0; i < vm.importRows.length; i++) {
        if (vm.importRows[i].length < majColNum) {
          unequalColErrs.push($translate.instant("common.import.csvErrRowWithTooFewCols", {
            row: (i + 1).toString()
          }));
        } else if (vm.importRows[i].length > majColNum) {
          unequalColErrs.push($translate.instant("common.import.csvErrRowWithTooManyCols", {
            row: (i + 1).toString()
          }));
        }
      }

      vm.errors = vm.errors.concat(unequalColErrs);

    }

    function getDisplayErrors() {
      //Only show 100 of these errors max to prevent UI issues
      return alkImportService.filterErrors(vm.errors);
    }

    function submit() {
      if (!vm.canSubmit()) return;
      vm.submitted = true;

      //Save these fields for next modal
      currentWizardData.file = vm.file;
      currentWizardData.importRows = vm.importRows;
      currentWizardData.delimiter = vm.delimiter;
      currentWizardData.detectedDelimiter = vm.detectedDelimiter;

      $uibModalInstance.close();
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function canSubmit() {
      return !vm.fileProcessing && vm.file && !vm.submitted && vm.errors.length === 0;
    }

    //Enter on file input button should submit form if file is uploaded
    function keydownOnFileInput($event) {
      if ($event.which === 13 && vm.canSubmit()) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.submit();
      }
    }

    $scope.$on("$destroy", function() {
      angular.element("#importForm").off();
      angular.element("#importSetFileInput").off();
      angular.element("#dragDropFileDiv").off();
    });

    /////////////////////////////////////
    //ROUTE Modifiers SPECIFIC OVERRIDES
    /////////////////////////////////////

    function validateExceptions() {
      vm.errors = [];

      //File selected: make sure it's a dat
      if (vm.file) {
        //Must be a .dat file
        var fileNamePieces = vm.file.name.split(".");
        if (fileNamePieces[fileNamePieces.length - 1] !== "dat") {
          vm.errors.push($translate.instant("templates.importModifiers.importModifiersNotDAT"));
        }
        if (vm.file.size > 2*1024*1024) {
          vm.errors.push($translate.instant("templates.importModifiers.importModifiersMaxFileSize", { maxFileSize: "2.0 MB" }));
        }
      }
    }

    function processFileLogicExceptions(file) {
      vm.file = file;
      vm.errors = [];
      if (!file) {
        return;
      }
      vm.validate();
    }

  }

})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/importModal.controller.js